var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#1E3A8A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2939 22.5786H23.3905L23.0703 22.2699C24.191 20.9663 24.8656 19.2739 24.8656 17.4328C24.8656 13.3276 21.538 10 17.4328 10C13.3276 10 10 13.3276 10 17.4328C10 21.538 13.3276 24.8656 17.4328 24.8656C19.2739 24.8656 20.9663 24.191 22.2699 23.0703L22.5786 23.3905V24.2939L28.2962 30L30 28.2962L24.2939 22.5786ZM17.4328 22.5786C14.5855 22.5786 12.287 20.2802 12.287 17.4328C12.287 14.5855 14.5855 12.287 17.4328 12.287C20.2802 12.287 22.5786 14.5855 22.5786 17.4328C22.5786 20.2802 20.2802 22.5786 17.4328 22.5786Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.352d96d1f2558b6a3e10fce5edd058f0.svg";
export { ForwardRef as ReactComponent };